import { Link } from "react-router-dom";
import PageTitle from "../ui/PageTitle";
import SearchPageFilters from "./SearchPageFilters";
import SearchPageResults from "./SearchPageResults";

export default function SearchPage() {

    return (
      <>
        <div className="page-div">
          <div data-aos="fade-down" className="title-area w-full">
            <PageTitle
              title="Search Results"
              breadcrumb={[
                { name: "home", path: "/" },
                { name: "Search Results", path: "/searchResults" },
              ]}
            />
          </div>

          <div data-aos="fade-up" className="aboutus-wrapper w-full">
            <div className="container-x mx-auto">
              <div className="w-full min-h-[665px] lg:flex lg:space-x-12 pb-10 lg:pb-0">

                  {/* FILTERS COLUMN */}

                  <SearchPageFilters></SearchPageFilters>

                  {/* RESULTS COLUMN */}

                  <SearchPageResults></SearchPageResults>

                  
              </div>
            </div>
          </div>
        </div>
      </>
    );
}